import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProposalUpdateComponent } from '../components/proposal-update/proposal-update.component';
import { CreateProposalComponent } from '../components/proposal-update/create-proposal/create-proposal.component';
import { UploadExcelComponent } from '../components/proposal-update/upload-excel/upload-excel.component';
import { TextConfComponent } from '../components/proposal-update/text-conf/text-conf.component';
import { DeepDiveComponent } from '../components/deep-dive/deep-dive.component';
import { PropSummaryComponent } from '../components/prop-summary/prop-summary.component';
import { AuthGuard } from '../auth/auth.guard';
import { AutomationOpportunitiesComponent } from '../components/automation-opportunities/automation-opportunities.component';
import { LandingComponent } from '../components/landing/landing.component';
import { TrendAnalysisComponent } from '../components/trend-analysis/trend-analysis.component';
import { ErrorComponent } from '../components/reusable/error/error.component';
import { AccessDeniedComponent } from '../components/reusable/access-denied/access-denied.component';
import { EditDiyProposalComponent } from '../components/proposal-update/edit-diy-proposal/edit-diy-proposal.component';


const approutes: Routes = [ 
  { path: "", component: LandingComponent, canActivate: [AuthGuard] },
  { path: "landing", component: LandingComponent, canActivate: [AuthGuard] },  
  { path: "createproposal", component: ProposalUpdateComponent, canActivate: [AuthGuard] },  
  { path: "proposalsummary", component: PropSummaryComponent, canActivate: [AuthGuard]},
  { path: "home/ticket", component: PropSummaryComponent, canActivate: [AuthGuard]},
  { path: "proposalsummary/:opportunityId", component: PropSummaryComponent, canActivate: [AuthGuard]},
  { path: "editproposal/:proposalId", component: CreateProposalComponent, canActivate: [AuthGuard] },  
  { path: "editproposal", component: CreateProposalComponent, canActivate: [AuthGuard] },  
  { path: "createproposal/create", component: CreateProposalComponent, canActivate: [AuthGuard] },
  { path: "editdiyproposal", component: EditDiyProposalComponent, canActivate: [AuthGuard] },  
  { path: "deepdive", component: DeepDiveComponent, canActivate: [AuthGuard] },
  { path: "Ticket/Index", component: DeepDiveComponent, canActivate: [AuthGuard] },
  { path: "Ticket/Home", redirectTo: "createproposal", pathMatch: 'full' },
  { path: "createdeepdive", component: ProposalUpdateComponent, canActivate: [AuthGuard] },
  { path: "Ticket/TicketCategoryDetails", component: TrendAnalysisComponent, canActivate: [AuthGuard] },  
  { path: "Ticket/proposalsummary", component: PropSummaryComponent, canActivate: [AuthGuard] },
  { path: "Ticket/AutomationMitigation", component: AutomationOpportunitiesComponent, canActivate: [AuthGuard] },
  { path: 'trendanalysis', component: TrendAnalysisComponent, canActivate: [AuthGuard] },
  { path: 'error', component: ErrorComponent, canActivate: [AuthGuard] },
  { path: 'accessdenied', component: AccessDeniedComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(approutes, { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
